'use client';
import useNavigator from '@shared/utils/hooks/useNavigator';
import { ChevronLeft } from 'lucide-react';
import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

type Props = {
  text?: string;
};

const GoBackButton = (props: Props) => {
  const router = useRouter();
  const navigator = useNavigator();

  // Lock display text to the initial value so that it doesn't change when the back navigation changes
  const [displayText] = useState(
    props.text
      ? props.text
      : (navigator.navigatorState.backNavigation?.context ?? 'Home')
  );

  return (
    <div
      className="flex cursor-pointer items-center space-x-2 text-textPrimary/60 hover:text-textSecondary/70"
      onClick={() => {
        router.replace(navigator.navigatorState.backNavigation?.path || '/');
        navigator.setBackNavigation({
          path: '/',
          context: undefined
        });
      }}
    >
      <ChevronLeft size={16} className="text-current" />
      <span className="text-sm font-emphasis">{displayText}</span>
    </div>
  );
};

export default GoBackButton;
